// src/components/GameControls.js
import React from 'react';
import './GameControls.css';
import { getLetterForBall } from '../bingoLogic';

function GameControls({
  currentBall,
  onDrawNext,
  onNewGame,
  remainingCount,
  isGameOver,
  onDeclareWinner,
  selectedRoundName,
  onTakeBreak,
  onShowCalledBalls // Prop for showing the modal
}) {

  const renderCurrentBall = () => {
    if (currentBall === null) {
      return <span className="placeholder">--</span>;
    }
    const letter = getLetterForBall(currentBall);
    return (
      <>
        <span className="current-ball-letter">{letter}</span>
        <span className="current-ball-number">{currentBall}</span>
      </>
    );
  };

  return (
    <div className="game-controls revised-controls is-active">
        <div className="status-display active-game-layout">
          {selectedRoundName && (
            <div className="selected-round-display emphasized-round-name">
              Playing: <strong>{selectedRoundName}</strong>
            </div>
          )}

          <div className="current-ball-area">
            <div className="current-ball-display large-display ball-shape">
              {renderCurrentBall()}
            </div>
            <div className="status-text">
              {isGameOver && <p className="game-over-message">All balls drawn!</p>}
              <p>{remainingCount} balls remaining</p>
            </div>
          </div>

          <button
            onClick={onDrawNext}
            disabled={isGameOver}
            className="control-button primary-next-ball-button"
          >
            Next Ball
          </button>

          <div className="secondary-actions-grid">
            <button
              onClick={onDeclareWinner}
              className="control-button declare-winner-button secondary-grid-button"
              title="Declare Bingo Winner"
              disabled={currentBall === null}
            >
              <i className="fas fa-trophy button-icon-small"></i> BINGO!
            </button>
            <button
                onClick={onTakeBreak}
                className="control-button take-a-break-button secondary-grid-button"
            >
                <i className="fas fa-pause button-icon-small"></i> Break
            </button>
            <button
              onClick={onShowCalledBalls} // Action for the new button
              className="control-button called-balls-history-button secondary-grid-button"
            >
              <i className="fas fa-list-ol button-icon-small"></i> Balls Called
            </button>
            <button
              onClick={onNewGame}
              className="control-button new-game-button secondary-grid-button"
            >
              <i className="fas fa-redo button-icon-small"></i> New Game
            </button>
          </div>
        </div>
    </div>
  );
}

export default GameControls;
